import {
  ProjectTouchedFields,
  ProjectDataProps,
  ShowAlertProps,
} from "../../Components/common/types";
import { v4 as uuidv4 } from "uuid";
import { project } from "../../config/variables";
import axios, { AxiosInstance } from "axios";
import {
  uploadFiles,
  syncUploadedFiles,
} from "../endpointsHelperFn/uploadFiles";
import { log } from "../logger";

export const handleAddProjectDetails = async (
  projectData: ProjectDataProps,
  setProjectData: React.Dispatch<React.SetStateAction<ProjectDataProps>>,
  setTouched: React.Dispatch<React.SetStateAction<ProjectTouchedFields>>,
  // validateWrapper: () => boolean,
  { showAlert, showLoader }: ShowAlertProps,
  api: AxiosInstance,
    fetchProjects?: () => Promise<void> // optional callback
): Promise<boolean> => {
  // Return a Promise<boolean>

  //Run validation
  // if (!validateWrapper()) {
  //   showAlert(
  //     true,
  //     "Validation Error",
  //     "Please fill in all required fields",
  //     false
  //   );

  //   return false; // Validation failed
  // }

  showLoader?.(true); // Show loader while processing, if defined

  try {
    // First: Upload files
    const results = await uploadFiles(
      [
        ...projectData.galleryData.imgData.map((img) => img.file),
        ...projectData.galleryData.vidData.map((vid) => vid.file),
      ].filter((file): file is File => !!file), // remove undefined, and narrow to File[]
      projectData.name,
      api
    );

    //sync results to the current project data
    const syncedData = await syncUploadedFiles(results, projectData);
    setProjectData(syncedData); // optional for UI

    log("Final payload", syncedData);

    // Create project and send to backend using axios
    // log("Final payload", projectData)
    const response = await api.post(project, syncedData);

    await fetchProjects?.(); // <-- Refetch to update UI

    // Reset project data
    setProjectData({
      id: uuidv4(),
      isOngoing: false,
      name: "",
      dateStarted: null,
      endDate: null,
      type: null,
      description: "",
      galleryData: { imgData: [], vidData: [] },
      links: { liveDemo: "", github: "" },
    });

    // Set all fields as untouched after submission
    const touchedFields: ProjectTouchedFields = Object.keys(
      projectData
    ).reduce((acc, key) => {
      if (
        key === "links" &&
        typeof projectData[key as keyof ProjectDataProps] === "object"
      ) {
        acc.links = Object.keys(
          projectData[key as keyof ProjectDataProps] as object
        ).reduce((linkAcc, linkKey) => {
          linkAcc[linkKey] = false;
          return linkAcc;
        }, {} as Record<string, boolean>);
      } else {
        acc[key as keyof ProjectTouchedFields] = false;
      }
      return acc;
    }, {} as ProjectTouchedFields);

    setTouched(touchedFields);

    // Hide loader if defined and show success alert
    showLoader?.(false);
    showAlert(false, "Success", response.data.message, false);
    return true; // Success
  } catch (error) {
    // console.error("Error:", error);
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const errorData = error.response?.data;
      if (status === 401 || status === 403) {
        return false; // Let the interceptor handle global errors
      }
      //Rest of the errors from project endpoints (e.g., 409 Conflict, 500 server errors)
      showAlert(true, "Error", errorData.message, false);
    } else {
      //Generic error from front end
      showAlert(
        true,
        "Error",
        "An unexpected error occurred during project submission. Please try again later.",
        false
      );
    }

    return false; // Unexpected error
  } finally {
    showLoader?.(false); // Hide loader regardless
  }
};
